import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import { Table } from "@dev2_techwalnut/tw-react-crud-dashlite";
import React, { useState } from "react";
import { NavLink, useNavigate, useSearchParams } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import Swal from "sweetalert2";

const columns = [
    {
        accessor: "operator_name",
        header: "operator name",
        cell: (row) => (
            <>{`${row?.operator_details?.first_name} ${row?.operator_details?.last_name}`}</>
        ),
    },
    {
        accessor: "department",
        header: "Department Name",
    },
];

const Operator = () => {
    const privileges = secureLocalStorage.getItem("privileges");
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const initialEntries = Number(searchParams.get("entries")) || 10;
    const initialPage = Number(searchParams.get("page")) || 1;
    const initialQueries = searchParams.get("q")?.split(",") || [];
    const initialColumns = searchParams.get("c")?.split(",") || [];

    const [entries, setEntries] = useState(initialEntries);
    const [pageIndex, setPageIndex] = useState(initialPage - 1);
    const [globalFilterValue, setGlobalFilterValue] = useState("");
    const [columnFilterKey, setColumnFilterKey] = useState("");
    const [columnFilterValue, setColumnFilterValue] = useState("");

    const { useFetch } = useAPIQuery({
        key: "operator",
        endpoint: "/api/operator/",
    });

    const { data, isLoading, isFetching } = useFetch({
        params: {
            entries: entries,
            page_no: pageIndex + 1,
            q: globalFilterValue !== "" ? globalFilterValue : columnFilterValue,
            c: globalFilterValue === "" ? columnFilterKey : "",
        },
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const { useDelete } = useAPIQuery({
        key: "operator",
        endpoint: "/api/operator/",
    });

    const { mutate: deleteData } = useDelete();

    const handleGlobalFilterChange = (value) => {
        const q = value?.trim() || "";
        if (q !== "") {
            setGlobalFilterValue(q);
            setColumnFilterKey("");
            setColumnFilterValue("");
            setSearchParams((searchParams) => {
                searchParams.set("q", q);
                searchParams.delete("c");
                return searchParams;
            });
        } else if (q === "") {
            setGlobalFilterValue("");
            setSearchParams((searchParams) => {
                searchParams.delete("q");
                return searchParams;
            });
        }
    };

    const handleColumnFilterChange = (value) => {
        const q = value.map((val) => val.value?.trim() || "").join(",");
        const c = value.map((val) => val.id).join(",");
        if (q !== "" && c !== "") {
            setGlobalFilterValue("");
            setColumnFilterKey(c);
            setColumnFilterValue(q);
            setSearchParams((searchParams) => {
                searchParams.set("q", q);
                searchParams.set("c", c);
                return searchParams;
            });
        } else if (q === "" && c === "") {
            setColumnFilterKey("");
            setColumnFilterValue("");
            setSearchParams((searchParams) => {
                searchParams.delete("q");
                searchParams.delete("c");
                return searchParams;
            });
        }
    };

    const handlePagination = (value) => {
        setSearchParams((searchParams) => {
            searchParams.set("entries", value.pageSize);
            searchParams.set("page", value.pageIndex + 1);
            return searchParams;
        });
        setPageIndex(value.pageIndex);
        setEntries(value.pageSize);
    };

    const handleEditRow = (row) => {
        console.log(row);
        navigate("/edit-operator", { state: { editpost: row.original } });
    };

    const handleDeleteRow = (row) => {
        console.log(row);
        const entry_id = row.original.id;
        Swal.fire({
            text: "Are you sure? You will not be able to recover this data!",
            showDenyButton: true,
            confirmButtonText: "Yes",
            denyButtonText: `No, cancel!`,
        }).then((result) => {
            if (result.isConfirmed) {
                deleteData({ id: entry_id });
            }
        });
    };

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content d-flex">
                        <h3 className="nk-block-title page-title">Operator</h3>
                        {/* {isLoading ? (
                            <div
                                className="spinner-border text-primary ms-2"
                                role="status"
                            >
                                <span className="sr-only"></span>
                            </div>
                        ) : (
                            ""
                        )} */}
                    </div>
                    {privileges.includes("operator_create") && (
                        <div className="nk-block-head-content">
                            <NavLink
                                to="/create-operator"
                                className="toggle btn btn-icon btn-primary d-md-none"
                                id="button-button-create-operator"
                            >
                                <em className="icon ni ni-plus"></em>
                            </NavLink>

                            <NavLink
                                to="/create-operator"
                                className="toggle btn btn-primary d-none d-md-inline-flex"
                                id="button-button-create-operator"
                            >
                                <em className="icon ni ni-plus"></em>
                                <span>Create Operator</span>
                            </NavLink>
                        </div>
                    )}
                </div>
            </div>

            <Table
                data={data ? data?.results.data : []}
                columns={columns}
                pagination
                pageIndex={pageIndex}
                pageSize={entries}
                rowCount={data ? data.count : 0}
                isLoading={isLoading || isFetching}
                globalSearch
                editRows={privileges.includes("operator_update") ? true : false}
                deleteRows={
                    privileges.includes("operator_delete") ? true : false
                }
                defaultGlobalSearchValue={
                    initialQueries.length > 0 && initialColumns.length <= 0
                        ? initialQueries[0]
                        : undefined
                }
                defaultColumnFiltersValue={
                    initialQueries.length > 0 && initialColumns.length > 0
                        ? initialColumns.map((column, index) => ({
                              id: column,
                              value: initialQueries?.[index] ?? "",
                          }))
                        : undefined
                }
                filterModal={false}
                selectRows={false}
                onGlobalFilterChange={handleGlobalFilterChange}
                onColumnFilterChange={handleColumnFilterChange}
                onRowEdit={handleEditRow}
                onRowDelete={handleDeleteRow}
                onPaginationChange={handlePagination}
            />
        </>
    );
};

export default Operator;
